import React, { useEffect } from "react";
import logo from "../../assets/images/logo.png";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";

/**
 * Renders Component.
 * @return {SignIn} renders Component.
 */
export default function SignIn() {
  useEffect(() => {}, []);

  return (
    <>
      <div className="container">
      <div className="row mt-4">
          <div className="col-2">
            <Form.Control
              type="text"
            />
          </div>
          <div className="col-2 ml-2">
            <Form.Control
              type="text"
            />
          </div>
          <div className="col-2 ml-2">
            <Form.Control
              type="text"
            />
          </div>
          <div className="col-2 ml-2">
            <Form.Control
              type="text"
            />
          </div>
          <div className="col-2 ml-2">
            <Form.Control
              type="text"
            />
          </div>
        </div>
      <div className="col-12 d-grid mt-3">
            <Button variant="primary" type="submit">
              Send
            </Button>
          </div>
      </div>
    </>
  );
}
